import styled from "styled-components";

export const HoldingPageMain = styled.main`
  color: ${(props) => props.theme.colours.foreground};
  margin: 0 auto;
  padding: 0 2rem;
  width: 100%;
  max-width: ${(props) => props.theme.screenSize.xl}px;
  @media (max-width: ${(props) => props.theme.screenSize.m}px) {
    padding: 0 1rem;
  }
`;
export const Main = styled.main`
  flex: 1; /* makes footer sticky, in conjunctions with flex styles on body in Layout */
  color: ${(props) => props.theme.colours.foreground};
  width: 100%;
  margin: 1rem auto;
`;
